import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import {
  clearScope,
  deleteFromScope,
  forceToggleGlobalsModal,
  selectIsForceOpenedGlobalsModal,
  selectPartnersInScope,
} from 'legacy/lut/features/partner360/composedReport'
import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const useScope = () => {
  const [showPartnersList, setShowPartnersList] = useState(false)
  const [showGlobalPartnersListForSelectEntities, setShowGlobalPartnersListForSelectEntities] =
    useState(false)
  const [showPasteFromClipboard, setShowPasteFromClipboard] = useState(false)

  const partnersInScope = useSelector(selectPartnersInScope)
  const isForceOpenedGlobalsModal = useSelector(selectIsForceOpenedGlobalsModal)
  const dispatch = useDispatch()

  const closeAddToScopeModal = useCallback(() => setShowPartnersList(false), [])

  const openAddToScopeModal = useCallback(() => {
    setShowPartnersList(true)
  }, [])

  const closeAddGlobalPartnersToScopeModal = useCallback(() => {
    dispatch(forceToggleGlobalsModal(false))
  }, [dispatch])

  const openAddToScopeFromGlobalModal = useCallback(() => {
    setShowGlobalPartnersListForSelectEntities(true)
  }, [])

  const closeAddToScopeFromGlobalModal = useCallback(() => {
    setShowGlobalPartnersListForSelectEntities(false)
  }, [])

  const openPasteFromClipboardModal = useCallback(() => {
    setShowPasteFromClipboard(true)
  }, [])

  const closePasteFromClipboardModal = useCallback(() => {
    setShowPasteFromClipboard(false)
  }, [])

  const onDeletePartnerFromScope = useCallback(
    (item: IWWPartners) => {
      dispatch(deleteFromScope(item))
    },
    [dispatch]
  )

  const onClearScope = useCallback(() => {
    dispatch(clearScope())
  }, [dispatch])

  return {
    closeAddToScopeModal,
    showPartnersList,
    openAddToScopeModal,
    partnersInScope,
    onDeletePartnerFromScope,
    onClearScope,
    openAddToScopeFromGlobalModal,
    closeAddToScopeFromGlobalModal,
    showGlobalPartnersListForSelectEntities,
    openPasteFromClipboardModal,
    closePasteFromClipboardModal,
    showPasteFromClipboard,
    showGlobalPartnersList: isForceOpenedGlobalsModal,
    closeAddGlobalPartnersToScopeModal,
  }
}
